import { StyleSheet } from "aphrodite";

export const style = StyleSheet.create({
    headerOne:{
        padding: '20px 20px',
        display: 'flex',
        boxShadow: '0px 1px 4px 0px rgba(204,204,204,0.8)'
    },
    header:{
        background: 'linear-gradient(to right, #4969D6, #29C6FF)',
    },
    title:{
        color: 'white',
        fontSize: '18px',
        lineHeight: '16px',
        display: 'flex',
        flex: '1',
        alignItems: 'center',
        textTransform: "uppercase"
    },
    divContainer:{
        display: 'flex',
    },
    divIcon:{
        display: 'flex',
        flex: '1',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    iconsMenu:{
        cursor: 'pointer'
    }
});
